import React, { ReactNode } from "react";

interface MetricCardProps {
  icon: ReactNode;
  iconBgColor: string;
  title: string;
  value: string | number;
  subtitle: string;
}

export default function MetricCard({
  icon,
  iconBgColor,
  title,
  value,
  subtitle,
}: MetricCardProps) {
  return (
    <div className="rounded-xl sm:rounded-2xl border border-gray-200 bg-white p-4 sm:p-5 shadow-sm dark:border-gray-800 dark:bg-white/[0.03]">
      <div
        className={`flex h-10 w-10 sm:h-12 sm:w-12 items-center justify-center rounded-lg sm:rounded-xl ${iconBgColor}`}
      >
        {icon}
      </div>
      <div className="mt-4 sm:mt-5">
        <p className="text-xs font-medium text-gray-600 dark:text-gray-400">
          {title}
        </p>
        <h4 className="mt-1.5 sm:mt-2 text-xl sm:text-2xl font-bold text-gray-900 dark:text-white">
          {value}
        </h4>
        <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
          {subtitle}
        </p>
      </div>
    </div>
  );
}
